import { Component, Input, ElementRef, ViewChild, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';

@Component({
  selector: 'nc-video-text',
  templateUrl: './video-text.component.html',
  styleUrls: ['./video-text.component.less']
})
export class VideoTextComponent implements OnChanges, AfterViewInit {
  /** 文本内容 */
  @Input() ncText: string = '';
  /** 视频源 */
  @Input() ncSrc: string = '';

  @ViewChild('textContent') textContentRef!: ElementRef<HTMLSpanElement>;
  @ViewChild('svgText') svgTextRef!: ElementRef<SVGTextElement>;

  dimensions = { width: 0, height: 0 };
  isReady: boolean = false;
  textStyle: Partial<CSSStyleDeclaration> = {};
  maskId: string = `aurora-mask-${Math.random().toString(36).substring(2, 11)}`;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ncText'] && !changes['ncText'].firstChange) {
      this.start();
    }
  }

  ngAfterViewInit(): void {
    this.start();
  }

  private start(): void {
    setTimeout(() => {
      this.computeTextStyles();
      this.updateDimensions();
    })
  }


  private computeTextStyles(): void {
    if (this.textContentRef?.nativeElement) {
      const computedStyle = getComputedStyle(this.textContentRef.nativeElement);
      this.textStyle = this.extractTextStyles(computedStyle);
    }
  }

  private updateDimensions(): void {
    if (this.svgTextRef?.nativeElement) {
      try {
        const bbox = this.svgTextRef.nativeElement.getBBox();
        this.dimensions = {
          width: Math.max(1, bbox.width),
          height: Math.max(1, bbox.height)
        };
        this.isReady = true;
      } catch (e) {
        console.error('获取 SVG 元素尺寸时出错:', e);
      }
    }
  }

  getStyleString(): string {
    let styleStr = '';
    for (const [key, value] of Object.entries(this.textStyle)) {
      if (value) {
        // 将驼峰命名转换为连字符命名
        const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        styleStr += `${cssKey}:${value};`;
      }
    }
    return styleStr;
  }

  // 提取文本相关样式的辅助方法
  private extractTextStyles(computedStyle: CSSStyleDeclaration): Partial<CSSStyleDeclaration> {
    return {
      fontSize: computedStyle.fontSize,
      fontFamily: computedStyle.fontFamily,
      fontWeight: computedStyle.fontWeight,
      fontStyle: computedStyle.fontStyle,
      letterSpacing: computedStyle.letterSpacing,
      lineHeight: computedStyle.lineHeight,
      textTransform: computedStyle.textTransform,
      fontVariant: computedStyle.fontVariant,
      fontStretch: computedStyle.fontStretch,
      fontFeatureSettings: computedStyle.fontFeatureSettings,
      textDecoration: computedStyle.textDecoration,
      textShadow: computedStyle.textShadow,
    };
  }
}
